import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <p>2026 Stickerei Zschoche</p>
        <nav>
          <Link to="/impressum-datenschutz">Impressum / Datenschutz</Link>
        </nav>
      </div>
    </footer>
  );
}
